import React, { useMemo } from 'react'
import { SortOption } from '@e3dc-react/shell/Elements/Sort'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { MobileSorting } from 'src/Libs/e-mobility/shared/components/MobileSorting'
import { ChargingSessionModel } from '../../models/charging-sessions.model'
import { useTypedSelector } from 'src/State/RootReducer'
import { useDispatch } from 'react-redux'
import { updateChargingSessionsFilters } from 'src/State/E-Mobility/EMobilityStateAction'

/**
 * Charging sessions sorting component.
 * It displays button for opening sorting mobile drawer.
 */
export const ChargingSessionMobileSort = (): JSX.Element => {
  const { t } = useCustomTranslation()

  const chargingSessionFilters = useTypedSelector(state => state.eMobility.chargingSessionsFilters.filters)
  const dispatch = useDispatch()

  const mobileSortableColumns: SortOption<ChargingSessionModel>[] = useMemo(
    () => [
      { value: 'startDateTime', label: t('emobility.chargingSession.startAt') },
      { value: 'durationMilliseconds', label: t('emobility.chargingSession.duration') },
      { value: 'consumptionKWh', label: t('emobility.chargingHistory.consumption') },
      { value: 'solarEnergyRatio', label: t('emobility.chargingSession.solarEnergyRatio') },
      { value: 'totalCost', label: t('emobility.chargingSession.cost') },
    ],
    [t]
  )

  const name = chargingSessionFilters?.sort ? chargingSessionFilters.sort.name : 'startDateTime'
  const direction = chargingSessionFilters?.sort ? chargingSessionFilters.sort.direction : 'desc'

  return (
    <MobileSorting
      value={{ name, direction }}
      defaultSortValue={{ name: 'startDateTime', direction: 'desc' }}
      sortOptions={mobileSortableColumns}
      onChange={sort => dispatch(updateChargingSessionsFilters({ ...chargingSessionFilters, sort, page: 0 }))}
    />
  )
}
